module.exports = __webpack_public_path__ + "static/media/now-hiring.dd65c92f.jpg";